import React, { useState, useEffect } from 'react';

function PartnersPage({ isOpen, onClose }) {
  const [isFlipped, setIsFlipped] = useState(false);
  const [isBackHovered, setIsBackHovered] = useState(false);
  const [isExploreActive, setIsExploreActive] = useState(false);
  const [bgImageLoaded, setBgImageLoaded] = useState(false);

  useEffect(() => {
    const bgImg = new Image();
    bgImg.src = '/images/Pattern Coming Soon Layout Cropped.png';
    bgImg.onload = () => setBgImageLoaded(true);

    const arrowImg = new Image();
    arrowImg.src = '/images/arrow.webp';
  }, []);

  useEffect(() => {
    if (isOpen) {
      setIsFlipped(false);
      const timer = setTimeout(() => setIsFlipped(true), 2000);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  useEffect(() => {
    if (!isFlipped) {
      const timer = setTimeout(() => setIsFlipped(true), 2000);
      return () => clearTimeout(timer);
    }
  }, [isFlipped]);

  if (!isOpen) return null;

  const handleToggle = () => {
    setIsFlipped(prev => !prev);
  };

  return (
    <>
      <div
        className="fixed inset-0 z-[9999] bg-black overflow-hidden"
        onClick={handleToggle}
      >
        <img
          src="/images/Pattern Coming Soon Layout Cropped.png"
          alt=""
          className={`absolute inset-0 w-full h-full object-cover transition-opacity duration-500 ${
            bgImageLoaded ? 'opacity-100' : 'opacity-0'
          }`}
          loading="eager"
          decoding="async"
          style={{
            willChange: 'opacity',
            imageRendering: 'crisp-edges',
            pointerEvents: 'none',
          }}
        />

        <div className="absolute top-0 left-0 right-0 h-24 sm:h-32 bg-gradient-to-b from-black/80 via-black/40 to-transparent z-[10000]"></div>

        <button
          onClick={(e) => {
            e.stopPropagation(); 
            onClose();
          }}
          onMouseEnter={() => setIsBackHovered(true)}
          onMouseLeave={() => setIsBackHovered(false)}
          onTouchStart={() => setIsBackHovered(true)}
          onTouchEnd={() => setIsBackHovered(false)}
          className="absolute top-4 left-4 sm:top-6 sm:left-6 md:top-8 md:left-8 text-white text-lg sm:text-xl md:text-2xl font-bold hover:text-[#C9A063] active:text-[#C9A063] transition-colors duration-300 z-[10001] flex items-center gap-2"
        >
          <img
            src="/images/arrow.webp"
            alt=""
            width="20"
            height="20"
            loading="eager"
            className={`transition-all duration-300 ease-in-out w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7 ${
              isBackHovered ? 'translate-x-0 opacity-100' : 'translate-x-4 opacity-0'
            }`}
          />
          Back
        </button>

       

        <div
          className="relative z-[1001] flex items-center justify-center min-h-screen p-4 sm:p-6 md:p-8 pt-24 pb-8"
        >
          <div
            className="relative w-full max-w-5xl mx-auto"
            style={{ perspective: '1500px' }}
          >
            <div
              className="relative w-full transition-transform duration-1000"
              style={{
                transformStyle: 'preserve-3d',
                transform: isFlipped ? 'rotateY(180deg)' : 'rotateY(0deg)',
              }}
            >
              {/* FRONT */}
              <div
                className="w-full cursor-pointer"
                style={{
                  backfaceVisibility: 'hidden',
                  WebkitBackfaceVisibility: 'hidden',
                  position: 'relative',
                  zIndex: isFlipped ? 1 : 2,
                }}
              >
                <picture>
                  <source
                    media="(max-width: 640px)"
                    srcSet="/images/partner.png"
                  />
                  <source
                    media="(max-width: 1024px)"
                    srcSet="/images/partners-tablet.webp"
                  />
                  <img
                    src="/images/IMG_5260.png"
                    alt="Partners"
                    loading="eager"
                    decoding="async"
                    className="w-full h-auto rounded-lg shadow-2xl"
                  />
                </picture>
              </div>

              {/* BACK */}
              <div
                className="absolute inset-0 w-full cursor-pointer"
                style={{
                  backfaceVisibility: 'hidden',
                  WebkitBackfaceVisibility: 'hidden',
                  transform: 'rotateY(180deg)',
                  zIndex: isFlipped ? 2 : 1,
                }}
              >
                <div className="bg-black rounded-lg shadow-2xl w-full h-full flex flex-col justify-center p-6 sm:p-8 md:p-10 lg:p-12 xl:p-16">
                  <div
                    className="text-center space-y-3 sm:space-y-4 md:space-y-5 mb-6 sm:mb-8"
                    style={{
                      WebkitFontSmoothing: 'antialiased',
                      MozOsxFontSmoothing: 'grayscale',
                      textRendering: 'optimizeLegibility',
                    }}
                  >
                    <p
                      className="text-sm sm:text-base md:text-lg lg:text-xl text-white leading-relaxed"
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      <span className="font-semibold">
                        We think incessantly about design. A dialogue between timeless
                        heritage and modern innovation. It is our ethos to sculpt spaces and
                        stories in rich African heritage while creating conditions that forge
                        transformative expressions.
                      </span>
                    </p>

                    <p
                      className="text-xs sm:text-sm md:text-base lg:text-lg text-white/90 leading-relaxed"
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      This ethos informs how we collaborate. We convene masters in Design,
                      Art, Architecture, and Technology — the keepers of Africa's timeless
                      traditions — and unite them with the world's most visionary brands,
                      the builders of form and function, and cultural institutions.
                    </p>

                    <p
                      className="text-xs sm:text-sm md:text-base lg:text-lg text-white/90 leading-relaxed"
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      At DAAT, our projects are a living exchange between memory and
                      modernity, rooted in African essence and spoken in a global voice.
                    </p>

                    <p
                      className="text-xs sm:text-sm md:text-base lg:text-lg text-white/90 leading-relaxed"
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      Our collaborators don't just create; they leave a mark. They don't
                      just innovate; they become part of a cultural shift.
                    </p>
                  </div>

                  <div
                    className="text-center"
                    onClick={(e) => e.stopPropagation()} // don't flip when clicking CTA
                  >
                    <a
                      href="mailto:celeste@daatglobal.com?subject=Partnership%20Inquiry"
                      onMouseEnter={() => setIsExploreActive(true)}
                      onMouseLeave={() => setIsExploreActive(false)}
                      onTouchStart={() => setIsExploreActive(true)}
                      onTouchEnd={() => setIsExploreActive(false)}
                      className={`inline-block px-6 sm:px-8 md:px-10 py-2.5 sm:py-3 md:py-3.5 text-sm sm:text-base md:text-lg font-medium text-white border-2 border-white rounded-full transition-all duration-300 no-underline cursor-pointer ${
                        isExploreActive ? 'scale-x-110 scale-y-105' : 'scale-100'
                      }`}
                      style={{ fontFamily: "'Poppins', sans-serif" }}
                    >
                      Explore a Partnership
                    </a>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        body {
          overflow: hidden;
        }
        ::-webkit-scrollbar {
          display: none;
        }
        * {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
    </>
  );
}

export default PartnersPage;
